import { useEffect } from 'react';

const OG_IMAGE = 'https://learnex.cc/assets/og-image.png';

export function usePageMeta(title: string, description: string, path?: string, type: string = 'website') {
  useEffect(() => {
    // Title
    document.title = title;
    
    // Helper to update or create meta tags
    const setMeta = (nameAttr: string, nameValue: string, content: string) => {
      let tag = document.querySelector(`meta[${nameAttr}="${nameValue}"]`);
      if (tag) {
        tag.setAttribute('content', content);
      } else {
        tag = document.createElement('meta');
        tag.setAttribute(nameAttr, nameValue);
        tag.setAttribute('content', content);
        document.head.appendChild(tag);
      }
    };

    // Description
    setMeta('name', 'description', description);
    
    // Open Graph
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:type', type);
    setMeta('property', 'og:image', OG_IMAGE);
    setMeta('property', 'og:image:width', '1200');
    setMeta('property', 'og:image:height', '630');
    
    // Twitter
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', OG_IMAGE);

    // Canonical & URL
    const url = `https://learnex.cc${path || window.location.pathname}`;
    setMeta('property', 'og:url', url);
    
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', url);
    } else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', url);
      document.head.appendChild(canonical);
    }
  }, [title, description, path, type]);
}